const pad = (value: number) => String(value).padStart(2, '0');

export const formatTime = (seconds: number) => {
  const wholeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const totalMinutes = Math.floor(wholeSeconds / 60);
  return `${pad(Math.floor(totalMinutes / 60))}:${pad(totalMinutes % 60)}:${pad(wholeSeconds % 60)}`;
};
